import { Component, OnDestroy, OnInit } from '@angular/core';
import { NewImportExportService } from '../../../_service/new-import-export.service';
import { Subscription } from 'rxjs';
import { User } from 'src/app/authentification/signin/credentials';

import { SigninService } from 'src/app/authentification/signin/signin.service';

@Component({
  selector: 'app-gloabl-stop-excel',
  templateUrl: './gloabl-stop-excel.component.html',
  styleUrls: ['./gloabl-stop-excel.component.css'],
})
export class GloablStopExcelComponent implements OnInit, OnDestroy {
  excelData: any[][] | null = null;
  excelData$: Subscription;
  current: string = '';
  public currentUser: User = new User();
  selectedRowIndex: number | null = null;
  rowspans: number[] = [];

  readonly headerTitleRowIndex = 0;
  readonly columnsHeaderRowIndex = 4;
  readonly dataStartIndex = 5;

  // Index des colonnes (ligne 5 du fichier)
  readonly COL_GROUPE = 0;
  readonly COL_VEHICULE = 1;
  readonly COL_CHAUFFEUR = 2;
  readonly COL_LIEU = 3;
  readonly COL_LATLNG = 4;
  readonly COL_DATE_ARRET = 5;
  readonly COL_TEMPS_ARRET = 6;
  readonly COL_DEPASSEMENT = 7;

  constructor(
    private importExportService: NewImportExportService,
    private authService: SigninService
  ) {
    const storedUser = localStorage.getItem('currentUser');
    this.currentUser = storedUser ? JSON.parse(storedUser) : {};
  }

  ngOnInit(): void {
    this.excelData$ = this.importExportService
      .getExcelData()
      .subscribe((value) => {
        if (
          value != null &&
          Array.isArray(value) &&
          value.every((row) => Array.isArray(row))
        ) {
          this.excelData = value as any[][];
          this.calculateRowspans();
          this.selectedRowIndex = null;
        }
      });
    this.fetchUser();
  }

  selectRow(index: number): void {
    this.selectedRowIndex = index;
  }

  fetchUser() {
    this.current = this.authService.getCurrentUser().displayName;
  }

  ngOnDestroy(): void {
    if (this.excelData$) {
      this.excelData$.unsubscribe();
    }
    this.importExportService.setExcelData(null);
    this.importExportService.setCurentRapport(null);
    this.importExportService.setPdfToBePrinted(null);
    this.importExportService.setExcelToBeProcessed(null);
    this.selectedRowIndex = null;
  }

  isEmptyColumn(index: number): boolean {
    if (!this.excelData || this.excelData.length <= this.dataStartIndex) {
      return true;
    }
    return this.excelData
      .slice(this.dataStartIndex)
      .every((row) => !this.cellText(row[index]));
  }

  /** Normalise une cellule en chaîne trimée (gère null/undefined/nombres). */
  private cellText(value: any): string {
    return value === null || value === undefined
      ? ''
      : value.toString().trim();
  }

  /**
   * Calcule le rowspan de la colonne "Groupe(s)" pour fusionner les lignes
   * consécutives qui partagent le même groupe.
   * Fix : on compare des valeurs trimées (cellText) plutôt que la valeur brute,
   * ce qui évite les ruptures de groupe dues à des espaces parasites.
   */
  calculateRowspans(): void {
    if (!this.excelData) return;

    const dataRows = this.excelData.slice(this.dataStartIndex);
    this.rowspans = Array(dataRows.length).fill(0);

    let i = 0;
    while (i < dataRows.length) {
      const cellValue = this.cellText(dataRows[i][this.COL_GROUPE]);
      if (cellValue !== '') {
        let rowspan = 1;
        let j = i + 1;

        while (
          j < dataRows.length &&
          (this.cellText(dataRows[j][this.COL_GROUPE]) === '' ||
            this.cellText(dataRows[j][this.COL_GROUPE]) === cellValue)
        ) {
          rowspan++;
          j++;
        }

        this.rowspans[i] = rowspan;

        for (let k = i + 1; k < i + rowspan; k++) {
          this.rowspans[k] = 0;
        }

        i += rowspan;
      } else {
        this.rowspans[i] = 0;
        i++;
      }
    }
  }

  /**
   * Convertit une cellule "LatLng" au format "lat;lng" en URL Google Maps.
   * Retourne null si la valeur est absente ou mal formée (le template
   * affiche alors le texte brut au lieu d'un lien).
   */
  getMapsUrl(latLng: any): string | null {
    const raw = this.cellText(latLng);
    if (!raw) return null;

    const parts = raw.split(';').map((p) => p.trim());
    if (parts.length !== 2) return null;

    const lat = parseFloat(parts[0]);
    const lng = parseFloat(parts[1]);
    if (isNaN(lat) || isNaN(lng)) return null;

    return `https://www.google.com/maps?q=${lat},${lng}`;
  }
}